import styled from "styled-components";

export const FestivalEventNoticeItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  > .title {
    font-weight: 700;
    font-size: 16px;
  }

  > .content {
    font-weight: 500;
    font-size: 12px;
    color: #808080;
    line-height: 140%;
  }
`;

export const FestivalEventNoticeTable = styled.div<{ open: boolean }>`
  width: 100%;
  border-radius: 12px;
  padding: 20px 15px 30px;
  background: #fff;
  opacity: ${(p) => (p.open ? "1" : "0")};
  transition: opacity 0.3s ease-in-out;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
